<template>
  <v-card :flat="flat" class>
    <v-card-title class="subheading">Últimos 5 fichajes realizados</v-card-title>
    <v-skeleton-loader
      v-if="loadingFichajes"
      class="mx-auto"
      max-width="300"
      type="list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line, list-item-two-line"
    ></v-skeleton-loader>
    <v-list two-line dense class="pb-2 caption" v-if="!loadingFichajes">
      <template v-for="(item,index) in fichajes">
        <v-list-item :key="'c-ult'+index" class>
          <v-list-item-content>
            <v-list-item-title>{{item.markDateTimeFec}}</v-list-item-title>
            <v-list-item-subtitle>{{ item.incidence }} {{ !!item.incidenceType ? ' - ' + item.incidenceType: '' }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class v-if="index + 1 < fichajes.length" :key="index"></v-divider>
      </template>
    </v-list>
  </v-card>
</template>
<script>
import fichajeServices from "@/services/fichajeServices.js";
import tipoIncidenciaServices from "@/services/tipoIncidenciaServices.js";
const moment = require("moment");
require("moment/locale/es");

export default {
  props: {
    flat: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fichajes: [],
      //formatDate: "DD/MM/YYYY HH:mm:ss",
      loadingFichajes: true,
      tiposIncidencias: []
    };
  },
  computed: {
    user: function() {
      return this.$store.state.authentication.user;
    }
  },
  mounted() {
    this.obtenerUltimosFichajes();
  },
  methods: {
    obtenerUltimosFichajes() {
      var that = this;
      this.loadingFichajes = true;
      const promises = [
        tipoIncidenciaServices.getTipos(),
        fichajeServices.getUltimosFichajes(this.user.employeeId)
      ];
      Promise.all(promises).then(values => {
        this.loadingFichajes = false;

        this.tiposIncidencias = values[0];
        this.fichajes = values[1];

        if (!!this.fichajes) {
          this.fichajes.forEach(item => {
            item.markDateTimeFec = moment
              .utc(item.markDateTime)
              .local()
              .format(that.getFormatoFechaToView);

            item.incidence =
              item.incidenceTypeId > 0 ? "Fichaje con incidencia" : "Fichaje";

            var typeI = that.tiposIncidencias.find(
              itemTipo => itemTipo.incidenceTypeId == item.incidenceTypeId
            );

            if (!!typeI) {
              item.incidenceType = typeI.name;
            }
          });
        }
      });

      // tipoIncidenciaServices.getTipos().then(res => {});

      // fichajeServices.getUltimosFichajes(this.user.employeeId).then(res => {
      //   this.loadingFichajes = false;
      //   this.fichajes = res;
      //   if (!!this.fichajes) {
      //     this.fichajes.forEach(arr => {
      //       console.log(arr);
      //       arr.markDateTimeFec = moment
      //         .utc(arr.markDateTime)
      //         .local()
      //         .format(this.formatDate);
      //     });
      //   }
      // });
    }
  }
};
</script>